import Request from '../../services/Request';
import ResponseChecker from '../../services/ResponseChecker';
import NotiMessage from '../../services/NotiMessage';

const notiMessage = new NotiMessage('success');

// URL //
const eachUrl = 'pa/getEach?';
const allUrl = 'pa/get?';
const storeUrl = 'pa/store';
const updateUrl = 'pa/update?';
const deleteUrl = 'pa/delete?';

const state = {
  pas: [],
  pa: {},
};
const getters = {};
const mutations = {
  SET_PAS(state, payload) {
    state.pas = payload.data.data;
  },
  SET_PA(state, payload) {
    state.pa = payload.data.data;
  },
  ADD_PA(state, payload) {
    state.pas.push(payload.data.data);
  },
  REMOVE_PA(state, payload) {
    const pas = state.pas.filter((item) => item.id != payload.id);
    state.pas = [...pas];
  },
};

const actions = {
  async getPAs({ commit }) {
    const response = await Request.get_data(allUrl)
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_PAS", response);
  },
  async getPA({ commit }, id) {
    const response = await Request.get_data(eachUrl, { column: 'id', value: id })
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_PA", response);
  },
  async createPA({ commit }, payload) {
    const response = await Request.post_data(storeUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("ADD_PA", response);
      notiMessage.displayNotiMsg('Saved Success')
      return true
    }
    return false;
  },
  async updatePA(context, payload) {
    const response = await Request.post_data(updateUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      notiMessage.displayNotiMsg('Updated Success')
      return true
    }
    return false;
  },
  async deletePA({ commit }, payload) {
    const response = await Request.post_data(deleteUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("REMOVE_PA", payload);
      notiMessage.displayNotiMsg('Deleted Success')
      return true
    }
    return false;
  },
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
